export default {"src":"/_next/static/media/logo.e76e9670.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};